import { t } from '@lingui/core/macro'
import { AppRoutes } from './routes'

function DesktopAppLink() {
  return (
    <a
      href="https://my.fiduly.com"
      aria-label={t`Open the full desktop application`}
      className="text-muted-foreground hover:bg-muted fixed right-4 bottom-4 z-10 hidden items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-medium opacity-30 transition-all hover:opacity-70 lg:inline-flex"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect width="20" height="14" x="2" y="3" rx="2" />
        <line x1="8" x2="16" y1="21" y2="21" />
        <line x1="12" x2="12" y1="17" y2="21" />
      </svg>
      my.fiduly.com
    </a>
  )
}

export function App() {
  return (
    <>
      <DesktopAppLink />
      <AppRoutes />
    </>
  )
}
